// extracted by mini-css-extract-plugin
export default {"panelContent":"G7QVi2bB_aWHIM3U0rYJ","blocksGrid":"ifDCabzLJkBevZyRjiZh","block":"OCCC8aT3elCeWCw_XZTp"};